import axios from 'axios';
import StorageService from '../services/StorageService';

class AdminHttpService {
    static async getAdmins(page = 1, search = '') {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/admin`,
                {
                    params: {
                        page,
                        ...(search && { search })
                    },
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async getLogs(page = 1, search = '', startDate = '', endDate = '') {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/admin/logs`,
                {
                    params: { 
                        page,
                        ...(search && { search }),
                        ...(startDate && { startDate: startDate }),
                        ...(endDate && { endDate: endDate })
                    },
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async deleteAdmin(adminId) {
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/admin/delete/${adminId}`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    static async createAdmin(name, email) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/admin`,
                { name, email },
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }
}

export default AdminHttpService;
